import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";

const initialState = {
  pendingCardStatus: "idle",
  RecheckPendingCardStatus: "idle",
  reissuePendingStatus: "idle",
  cardData: {
    Pending: [],
  },
  cardRecheckData: {
    Pending: [],
  },
  cardReissueData: {
    Pending: [],
  },
  currentPage: 1,
  currentCardPage: 1,
  currentFilter: "all",
  currentPageSize: 60,
  currentRecheckPage: 1,
  currentRecheckPageSize: 60,
  currentReissuePage: 1,
  currentReissuePageSize: 60,
  sortBy: "",
  sortOrder: "",
  search: "",
  searchOrder: "",
  showTable: false,
  selectedId: null,
  selectedListId: "",
  total: {
    Pending: "",
  },
  gli_id: "",
  tableData: [],
  printModal: false,
  selectedItems: [],
  printingData: [],
  printUI: false,
  clear: false,
  formData: {},
  showForm: false,
  itemTypeId: "",
  card_size: 1,
  verifyCertificateBtn: false,
  isMultiGliPrint: false,
  bulkPassModal: false,
  isMultiPrint: false,
  isEdit: false,
  data: [],
  activeId: 1,
  item_status: "",
  gliform: {
    certificate_type: "",
    side: "",
    card_size: {
      name: "Normal (7.8)",
      id: 1,
    },
    remarks: "",
    certificate_format: "",
    gli_data: [{ gli_number: null, status: [], report_id: null, _id: null }],
    item_type: "",
    gli: [],

    is_multi_print_confirm: false,
  },
  is_multi_print: false,
  multipleTableData: {},
  multipleTableAllData: [],
  multipleRecheckTableData: {},
  multipleReissueTableData: {},
  transformedGliDataOrder: {},
};

export const getPrintingList = createAsyncThunk(
  "old-certificate/card/assigned-list",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(
        `/employee-dashboard/order/pending-queue`,
        params,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getPrintingRecheckList = createAsyncThunk(
  `old-certificate/employee-dashboard/recheck/assigned-to-me`,
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(
        `/employee-dashboard/recheck/pending-queue`,
        params,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getPrintingReissueList = createAsyncThunk(
  `old-certificate/employee-dashboard/pending-queue`,
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(
        `printing-report/old-certificate/pending-queue`,
        params,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const printingOldCardReissueSlice = createSlice({
  name: "printingOldCardReissue",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: {
    // pending list
    //
    [getPrintingList.pending]: (state, action) => {
      state.pendingCardStatus = "pending";
    },
    [getPrintingList.fulfilled]: (state, action) => {
      const newData = action.payload.data.data.data;
      const uniqueItems = {};
      const combinedPending = [];
      // Add existing items with unique _id values to uniqueItems
      state.cardData.Pending.forEach((item) => {
        uniqueItems[item._id] = true;
        combinedPending.push(item);
      });
      // Add new items with unique _id values to uniqueItems and combinedPending
      newData.forEach((item) => {
        if (!uniqueItems[item._id]) {
          uniqueItems[item._id] = true;
          combinedPending.push(item);
        }
      });
      if (state.search != "") {
        if (state.currentPage == 1) {
          state.cardData.Pending = newData;
        } else {
          if (
            state.cardData.Pending?.length <=
            action.payload.data.data.total_count
          ) {
            state.cardData.Pending = [...state.cardData.Pending, ...newData];
          }
        }
      } else {
        state.cardData.Pending = combinedPending;
      }
      // state.cardData.Pending = combinedPending;
      state.total.Pending = action.payload.data.data.total_count;
      state.pendingCardStatus = "fulfilled";
    },
    [getPrintingList.rejected]: (state, action) => {
      state.pendingCardStatus = "failed";
    },

    //recheck list
    [getPrintingRecheckList.pending]: (state, action) => {
      state.RecheckPendingCardStatus = "pending";
    },
    [getPrintingRecheckList.fulfilled]: (state, action) => {
      const newData = action.payload.data.data.data;
      const uniqueItems = {};
      const combinedPending = [];
      // Add existing items with unique _id values to uniqueItems
      state.cardRecheckData.Pending.forEach((item) => {
        uniqueItems[item._id] = true;
        combinedPending.push(item);
      });
      // Add new items with unique _id values to uniqueItems and combinedPending
      newData.forEach((item) => {
        if (!uniqueItems[item._id]) {
          uniqueItems[item._id] = true;
          combinedPending.push(item);
        }
      });
      state.cardRecheckData.Pending = combinedPending;
      state.total.Pending = action.payload.data.data.total_count;
      state.RecheckPendingCardStatus = "fulfilled";
    },
    [getPrintingRecheckList.rejected]: (state, action) => {
      state.RecheckPendingCardStatus = "failed";
    },
    //reissue list
    [getPrintingReissueList.pending]: (state, action) => {
      state.reissuePendingStatus = "pending";
    },
    [getPrintingReissueList.fulfilled]: (state, action) => {
      const newData = action.payload.data.data.data;
      const uniqueItems = {};
      const combinedPending = [];
      // Add existing items with unique _id values to uniqueItems
      state.cardReissueData.Pending.forEach((item) => {
        uniqueItems[item._id] = true;
        combinedPending.push(item);
      });
      // Add new items with unique _id values to uniqueItems and combinedPending
      newData.forEach((item) => {
        if (!uniqueItems[item._id]) {
          uniqueItems[item._id] = true;
          combinedPending.push(item);
        }
      });
      state.cardReissueData.Pending = combinedPending;
      state.total.Pending = action.payload.data.data.total_count;
      state.reissuePendingStatus = "fulfilled";
    },
    [getPrintingReissueList.rejected]: (state, action) => {
      state.reissuePendingStatus = "failed";
    },
  },
});

export const { updateConfig } = printingOldCardReissueSlice.actions;

export default printingOldCardReissueSlice.reducer;
